/**
 * Inline type-check when you're sure something isn't null, but Typescript makes you check anyway.
 */
export function defined<T>(thing: T | undefined | null): T {
    if (thing === undefined || thing === null) {
        throw new Error('Unexpected ' + thing);
    }
    return thing;
}

export function isDefined<T>(thing: T | undefined | null): thing is T {
    return thing !== undefined && thing !== null;
}
